import React, { useContext, useState } from "react";
import { Grid, Paper, Typography, CardActionArea } from "@material-ui/core";
import SimpleBar from "simplebar-react";
import "simplebar/src/simplebar.css";
import { AppContext } from "../../context/reducer";
import WebpageIcon from "@material-ui/icons/WebAsset";

const MenuAppItem = ({ logo, title, onUpdateFrameStatus, url, type }) => {
  const onClick = (type, url) => {
    url = url.match(/^http[s]?:\/\//) ? url : "http://" + url;
    type === "redirect" ? window.open(url, "_blank") : onUpdateFrameStatus(url);
  };
  const [hover, setHover] = useState(false);
  return (
    <CardActionArea
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={() => onClick(type, url)}
      style={{ minHeight: 85, textAlign: "center", borderRadius: 4 }}
    >
      <div style={{ padding: 5 }}>
        {logo ? (
          <div
            style={{
              transform: `${hover ? "scale(1.0)" : "scale(0.9)"}`,
              transition: "0.3s",
              pointerEvents: "none",
              objectFit: "contain",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <img
              alt={title || window.t["Link Image"]}
              src={logo}
              height={48}
            />
          </div>
        ) : (
          <div
            style={{
              textAlign: "center",
              fontSize: 48,
              transform: `${hover ? "scale(1.0)" : "scale(0.9)"}`,
              transition: "0.3s",
              pointerEvents: "none",
              margin: "-6px 0",
              
            }}
          >
            <WebpageIcon color="primary" fontSize="inherit" />
          </div>
        )}
        <Typography
          color="textSecondary"
          variant="body2"
          noWrap
          style={{ margin: "5px 0" }}
        >
          {title}
        </Typography>
      </div>
    </CardActionArea>
  );
};

const MenuOptions = ({ onUpdateFrameStatus }) => {
  const { state } = useContext(AppContext);

  return (
    <SimpleBar
      style={{
        width: 328,
        maxHeight: 448,
        padding: 20,
      }}
    >
      <Paper elevation={0}>
        <Grid container spacing={2}>
          {state.apps.map((item, key) => (
            <Grid key={key} item xs={4}>
              <MenuAppItem
                logo={item.logo}
                title={item.title}
                url={item.url}
                type={item.type}
                onUpdateFrameStatus={onUpdateFrameStatus}
              />
            </Grid>
          ))}
        </Grid>
      </Paper>
    </SimpleBar>
  );
};

export default MenuOptions;
